import script from "./BangKeChiTietXuatPrintModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BangKeChiTietXuatPrintModal.vue?vue&type=script&lang=ts&setup=true"

import "./BangKeChiTietXuatPrintModal.vue?vue&type=style&index=0&id=6fbc5e8d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fbc5e8d"]])

export default __exports__